module.exports = __webpack_public_path__ + "static/img/li2_8.f94b120c.png";